import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { MatDialog } from '@angular/material';
import { DatosGeneralesSAE } from '../../../datos-generales-SAE';
import { Salida } from '../../../models/entradaAlmacen';
import * as moment from 'moment';

@Component({
  selector: 'agregarSalida-component',
  styles: [],
  templateUrl: './agregarSalida.component.html',
  providers: [generalService]
})

export class agregarSalidaComponent {
  constructor(private formBuilder: FormBuilder,
    private _generalService: generalService,
    public dialog: MatDialog,
    public dataService: DataService) {
    this.salidaForm = new FormGroup({});
    this.salidaModel = new Salida();
    this.salidaModel.idSucursal = this.idSucursal;
    this.salidaModel.idUsuario = this.idUsuario;
    this.salidaModel.almacen = null;
    this.productosList = new Array();
    this.productosDeleted = new Array();

    if (this.dataService.tipo === "editar") {
      this.isUpdate = true;
      this.idSalida = this.dataService.id;
      this.datosGeneralesSAE = DatosGeneralesSAE;
    }

    if (this.dataService.tipo === "ver") {
      this.isUpdate = true;
      this.readOnly = true;
      this.idSalida = this.dataService.id;
      this.datosGeneralesSAE = DatosGeneralesSAE;
    }
  }

  @Output() recargarHistorico = new EventEmitter<boolean>();

  public salidaForm: FormGroup;
  public salidaModel: Salida;
  public tipoSalidas = [];
  public almacenes = [];
  public statusSalidas = [
    { statusSalida: "Abierta", idStatusSalida: 0 },
    { statusSalida: "Cerrada", idStatusSalida: 1 }];
  public idSalida: number;

  public productoForm: FormGroup;
  public productosList: any;
  public noProducto: number = 0;
  public idRegistro: number;
  public idProducto: number;
  public cantidadDisponible: string;
  public cantidad: number;
  public piezasDisponibles: string;
  public piezasContenedor: number;
  public piezasContenedorOriginal: number;
  public familias = [];
  public subfamilias = [];
  public productos = [];
  public productosDeleted: any;

  public datosGeneralesSAE: any;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public idSucursal: any = this.userData.ORGANIZATION_ID;
  public idCompania: any = this.userData.COMPANY_ID;
  public idUsuario: any = this.userData.USER_ID;
  public isUpdate: boolean = false;
  public readOnly: boolean = false;

  public dataInventario: any[];

  ngOnInit() {
    this.buildForms();
    this.tipoSalidaGetList();
    this.almacenesGetList();

    if (this.isUpdate) {
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.salidaGetbyID();
      this.salidaDetalleGetList();
    }
    setTimeout(() => {
      this.salidaForm.updateValueAndValidity();
    }, 0);
  }

  buildForms() {
    this.salidaForm = this.formBuilder.group({
      noSalida: this.formBuilder.control({ value: null, disabled: true }),
      tipoSalida: this.formBuilder.control(null, [Validators.required]),
      almacen: this.formBuilder.control(null, [Validators.required]),
      statusSalida: this.formBuilder.control(null, [Validators.required]),
      observaciones: this.formBuilder.control(null)
    });
    this.productoForm = this.formBuilder.group({});

    if (this.isUpdate) {
      this.salidaForm.disable();
      this.salidaForm.controls['statusSalida'].enable();
    }
    if (this.readOnly) {
      this.salidaForm.disable();
    }
  }

  tipoSalidaGetList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCall('SalidaAlmacen/tipoSalidaGetList')
        .subscribe(result => {
          result = JSON.parse(result);
          this.tipoSalidas = result;
          resolve();
        }, error => {
          reject();
        });
    });
  }

  almacenesGetList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(this.idSucursal, 'SalidaAlmacen/almacenesGetList')
        .subscribe(result => {
          result = JSON.parse(result);
          this.almacenes = result;
          resolve();
        }, error => {
          reject();
        });
    });
  }

  onSubmit() {
    let tipo = 'agregar';
    let link = 'SalidaAlmacen/salidaInsert/';
    this.salidaModel.fechaRegistro = moment().format('YYYY-MM-DD HH:mm:ss');
    this._generalService
      .metodoCallParamsPutPost(tipo, this.salidaModel, link)
      .subscribe(result => {
        result = JSON.parse(result);
        this.idSalida = result[0].idSalida;
        if (this.idSalida === 0) {
          this._generalService
            .toastCall(result[0].mensaje);
          this.salidaClean();
        }
        else {
          this.salidaDetallesInsert(this.idSalida);
          this._generalService
            .toastCall("Salida registrada correctamente");
          this.salidaClean();
        }
        this.recargarHistorico.emit();
      }, (error) => {
        const errorMsj = error as any;
        console.log(errorMsj);
      });
  }

  productoFormAdd(noProducto: number) {
    this.productoForm.addControl('nombreProducto' + noProducto, this.formBuilder.control(null, [Validators.required]));
    this.productoForm.addControl('cantidadDisponible' + noProducto, this.formBuilder.control({ value: null, disabled: true }, []));
    this.productoForm.addControl('cantidadProducto' + noProducto, this.formBuilder.control(null, [Validators.required]));
    this.productoForm.addControl('piezasDisponibles' + noProducto, this.formBuilder.control({ value: null, disabled: true }, []));
    this.productoForm.addControl('piezasContenedorProducto' + noProducto, this.formBuilder.control(null, []));

    // NUEVO
    this.productoForm.addControl('warehouseMoveDetail' + noProducto, this.formBuilder.control(null, []));
  }

  productoFormRemove(noProducto: number) {
    this.productoForm.removeControl('nombreProducto' + noProducto);
    this.productoForm.removeControl('cantidadDisponible' + noProducto);
    this.productoForm.removeControl('cantidadProducto' + noProducto);
    this.productoForm.removeControl('piezasDisponibles' + noProducto);
    this.productoForm.removeControl('piezasContenedorProducto' + noProducto);

    // NUEVO
    this.productoForm.removeControl('warehouseMoveDetail' + noProducto);
  }

  private companiasConSelectorDetalle: number[] = [17]; // ejemplo

  showDetalleSelectorByCompany(): boolean {
    return this.companiasConSelectorDetalle.includes(Number(this.idCompania));
  }

  debeMostrarSelectorDetalle(item: any): boolean {
    return this.showDetalleSelectorByCompany()
      && !this.readOnly
      && Number(item.cantidad) === 1
      && item.idProducto != null;
  }

  cargarWarehouseMoveDetailsDisponibles(item: any): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.salidaModel.almacen || !item.idProducto) {
        item.warehouseMoveDetailsDisponibles = [];
        item.warehouseStockInvoiceIdSeleccionado = null;
        item.showSelectorDetalle = false;
        resolve();
        return;
      }

      if (!this.debeMostrarSelectorDetalle(item)) {
        item.warehouseMoveDetailsDisponibles = [];
        item.warehouseStockInvoiceIdSeleccionado = null;
        item.showSelectorDetalle = false;
        resolve();
        return;
      }

      item.loadingDetalle = true;

      const payload = {
        idAlmacen: this.salidaModel.almacen,
        idProducto: item.idProducto,
        idSucursal: this.idSucursal
      };


      this._generalService
        .metodoCallParamsPutPost('agregar', payload, 'SalidaAlmacen/salidaDetalleSelectGetList/')
        .subscribe(result => {
          result = JSON.parse(result);

          item.warehouseMoveDetailsDisponibles = result || [];
          item.showSelectorDetalle = item.warehouseMoveDetailsDisponibles.length > 0;

          if (!item.showSelectorDetalle) {
            item.warehouseStockInvoiceIdSeleccionado = null;
            this.productoForm.controls['warehouseMoveDetail' + item.noProducto].setValue(null);
          }

          item.loadingDetalle = false;
          resolve();
        }, error => {
          item.loadingDetalle = false;
          item.warehouseMoveDetailsDisponibles = [];
          item.warehouseStockInvoiceIdSeleccionado = null;
          item.showSelectorDetalle = false;
          reject();
        });
    });
  }

  AddToList() {
    this.noProducto++;
    this.productoFormAdd(this.noProducto);
    this.productosList
      .push({
        noProducto: this.noProducto,
        idRegistro: this.idRegistro,
        idProducto: this.idProducto,
        cantidad: this.cantidad,
        cantidadDisponible: this.cantidadDisponible,
        piezasContenedor: this.piezasContenedor,
        piezasDisponibles: this.piezasDisponibles,
        contenedorDecimales: false,
        piezasContenedorOriginal: this.piezasContenedorOriginal,
        statusRegistro: 1,
        showPzContenedor: false,

        // --- NUEVO ---
        warehouseMoveDetailsDisponibles: [],
        warehouseStockInvoiceIdSeleccionado: null,
        showSelectorDetalle: false,
        loadingDetalle: false,

        // --- buscador ---
        itemsShow: 10,
        filteredItemsShow: 10,
        isFilteredProd: false,
        arrayFilteredProd: undefined,
        searchProduct: '',
        productosFiltrados: this.productos.slice(0, 10)

      });
  }


  private normalizeText(s: any): string {
    return (s ?? '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private tokenize(s: any): string[] {
    return this.normalizeText(s)
      .split(' ')
      .filter(t => t.length >= 2);
  }

  filtrarProductoSalida(item: any) {
    let arr: any[];
    const tokens = this.tokenize(item.searchProduct);

    if (tokens.length) {
      item.arrayFilteredProd = this.productos.filter((obj: any) => {
        const haystack = this.normalizeText(`${obj.SKU || ''} ${obj.nombre || ''}`);
        return tokens.every(t => haystack.includes(t)); // AND
      });

      item.filteredItemsShow = 10;
      arr = item.arrayFilteredProd.slice(0, item.filteredItemsShow);
      item.isFilteredProd = true;
    } else {
      item.isFilteredProd = false;
      item.filteredItemsShow = 10;
      item.arrayFilteredProd = undefined;

      item.itemsShow = 10;
      arr = this.productos.slice(0, item.itemsShow);
    }

    item.productosFiltrados = arr;
  }

  removeFromList(indice) {
    let noProducto = this.productosList[indice].noProducto;

    if (this.productosList[indice].statusRegistro === 1) {
      this.productosList.splice(indice, 1);
    }
    if (this.productosList[indice].statusRegistro === 2) {
      this.productosDeleted.push(this.productosList[indice]);
      this.productosList.splice(indice, 1);
    }

    this.productoFormRemove(noProducto);
  }

  productosGetList(idAlmacen): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(idAlmacen, 'SalidaAlmacen/productosGetList')
        .subscribe(result => {
          result = JSON.parse(result);
          this.productos = result;

          // inicializa para items ya existentes (editar/ver)
          if (this.productosList && this.productosList.length) {
            for (let i = 0; i < this.productosList.length; i++) {
              const item = this.productosList[i];
              item.itemsShow = 10;
              item.filteredItemsShow = 10;
              item.isFilteredProd = false;
              item.arrayFilteredProd = undefined;
              item.searchProduct = item.searchProduct || '';
              item.productosFiltrados = this.productos.slice(0, item.itemsShow);
            }
          }

          resolve();
        }, error => {
          reject();
        });
    });
  }

  productoGetValues(idItem, idRegistro) {
    for (let i = 0; i < this.productos.length; i++) {
      if (this.productos[i].idItem === idItem) {
        this.productosList[idRegistro].cantidadDisponible =
          this.productos[i].cantidadDisponible + ' ' + this.productos[i].unidadCantidad;
        this.productosList[idRegistro].piezasDisponibles =
          this.productos[i].piezasDisponibles + ' ' + this.productos[i].unidadPiezas;
        this.productosList[idRegistro].contenedorDecimales =
          this.productos[i].contenedorDecimales;
      }
    }

    let idProducto = this.productosList[idRegistro].idProducto;
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(idProducto, 'EntradaAlmacen/productoPiezasGetValue/')
        .subscribe(result => {
          result = JSON.parse(result);
          this.productosList[idRegistro].piezasContenedor = result[0].piezasContenedor;
          this.productosList[idRegistro].piezasContenedorOriginal = result[0].piezasContenedor;

          if (!this.productosList[idRegistro].contenedorDecimales && this.productosList[idRegistro].piezasContenedorOriginal == 1) {
            this.productosList[idRegistro].showPzContenedor = false;
          } else {
            this.productosList[idRegistro].showPzContenedor = true;
          }

          console.log(this.productosList[idRegistro]);
        }, error => {
          reject();
        });
    });

    this.productosList[idRegistro].warehouseStockInvoiceIdSeleccionado = null;
    this.productosList[idRegistro].warehouseMoveDetailsDisponibles = [];
    this.productosList[idRegistro].showSelectorDetalle = false;

    this.cargarWarehouseMoveDetailsDisponibles(this.productosList[idRegistro]);

  }

  onCantidadChange(item: any) {
    if (this.debeMostrarSelectorDetalle(item)) {
      this.cargarWarehouseMoveDetailsDisponibles(item);
    } else {
      item.warehouseStockInvoiceIdSeleccionado = null;
      item.warehouseMoveDetailsDisponibles = [];
      item.showSelectorDetalle = false;

      const control = this.productoForm.controls['warehouseMoveDetail' + item.noProducto];
      if (control) {
        control.setValue(null);
      }
    }
  }

  salidaDetallesInsert(idSalida: number) {
    for (let i = 0; i < this.productosList.length; i++) {
      let tipo = 'agregar';
      let registro = {
        idSalida: idSalida,
        idRegistro: this.productosList[i].idRegistro,
        idProducto: this.productosList[i].idProducto,
        cantidad: this.productosList[i].cantidad,
        piezasContenedor: this.productosList[i].piezasContenedor,
        idUsuario: this.idUsuario,
        fechaUpdate: moment().format('YYYY-MM-DD HH:mm:ss'),

        // NUEVO
        warehouse_stock_invoice_id: this.productosList[i].warehouseStockInvoiceIdSeleccionado
      };
      let link;

      if (this.productosList[i].statusRegistro === 1) {
        link = 'SalidaAlmacen/salidaDetallesInsert/';
      }
      if (this.productosList[i].statusRegistro === 2) {
        link = 'SalidaAlmacen/salidaDetallesUpdate/';
      }

      this._generalService
        .metodoCallParamsPutPost(tipo, registro, link)
        .subscribe(result => {
          //result = JSON.parse(result);
          this.dataService.guardado = true;
        }, (error) => {
          const errorMsj = error as any;
          this._generalService.toastCall(errorMsj);
        });
    }

    if (this.productosDeleted.length > 0) {
      for (let i = 0; i < this.productosDeleted.length; i++) {
        let registro = this.productosDeleted[i].idRegistro;
        this._generalService
          .metodoCallParams(registro, 'EntradaAlmacen/entradaDetallesDelete/')
          .subscribe(result => {
            if (result != "") {
              //this._generalService.toastCall(result); 
            }
          },
            error => {
              var errorMsj = <any>error;
              console.log(errorMsj);
            });
      }
    }

  }

  salidaClean() {
    this.productoForm.reset();
    this.salidaForm.reset();

    for (let i = 0; i <= this.productosList.length; i++) {
      this.productoFormRemove(i);
    }
    this.productosList.splice(0, this.productosList.length);

    this.salidaForm.enable();
    this.productoForm.enable();
    this.salidaForm.controls['noSalida'].disable();
    this.salidaModel.almacen = 0;
  }
  //LAS FUNCIONES A CONTINUACIÓN SON POR DE LA MODALIDAD DE EDICIÓN.
  salidaGetbyID(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(this.idSalida, 'SalidaAlmacen/salidaGetbyID/')
        .subscribe(result => {
          result = JSON.parse(result);
          this.salidaModel = result[0];
          this.productosGetList(this.salidaModel.almacen);
          resolve();
        }, error => {
          reject();
        });
    });
  }

  salidaDetalleGetList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(this.idSalida, 'SalidaAlmacen/salidaDetalleGetList/')
        .subscribe(result => {
          result = JSON.parse(result);
          this.productosList = result;
          for (let i = 0; i < this.productosList.length; i++) {
            this.noProducto = this.productosList[i].noProducto;
            this.productoFormAdd(this.noProducto);
            this.productoForm.controls['nombreProducto' + this.productosList[i].noProducto].disable();

            if (!this.productosList[i].contenedorDecimales && this.productosList[i].piezasContenedorOriginal == 1) {
              this.productosList[i].showPzContenedor = false;
            } else {
              this.productosList[i].showPzContenedor = true;
            }
          }
          if (this.readOnly) {
            this.productoForm.disable();
          }
          this.datosGeneralesSAE.showSpinnerLoading = false;
          resolve();
        }, error => {
          reject();
        });
    });
  }

  submitUpdate() {
    if (this.salidaModel.statusSalida === 0) {
      this.salidaDetallesInsert(this.idSalida);
      this._generalService.toastCall("La salida se modificó exitosamente!");
      this.cerrarModal();
    } else {
      let fechaUpdate = moment().format('YYYY-MM-DD HH:mm:ss');
      let webService = 'SalidaAlmacen/salidaUpdate?idSalida=' + this.idSalida + '&&fechaUpdate=' + fechaUpdate;
      this._generalService
        .metodoCall(webService, true)
        .subscribe(result => {
          console.log(result);
          this.salidaDetallesInsert(this.idSalida);
          this._generalService.toastCall("La salida se modificó exitosamente!");
          this.cerrarModal();
        }, error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        });
    }
  }

  cerrarModal() {
    this.dataService.dialogRef.close();
  }

  //SEGUNDA EDICIÓN DEL CODIGO, ACTUALIZACIONES E INCIDENCIAS
  validacionesSalida() {
    if (this.productosList.length > 0) {
      this.salidaForm.disable();
      this.productoForm.disable();
      let countVal = 0;
      let cantZero = 0;
      let decimVal = 0;

      for (let i = 0; i < this.productosList.length; i++) {
        let PLpzas
        if (this.productosList[i].piezasContenedor != null) {
          PLpzas = this.productosList[i].piezasContenedor;
        }
        else {
          PLpzas = 0;
        }
        let PLcont = this.productosList[i].cantidad;
        let PLsoli = PLpzas * PLcont;
        let pszOrig = this.productosList[i].piezasContenedorOriginal;
        let PLidPr = this.productosList[i].idProducto;

        let cantPzs, cantCon, cantSol;

        for (let i = 0; i < this.productos.length; i++) {
          if (this.productos[i].idItem === PLidPr) {
            cantCon = this.productos[i].cantidadDisponible;
            cantSol = this.productos[i].piezasDisponibles;
            cantPzs = cantSol / cantCon;
          }
        }

        if (PLsoli > 0) {
          if (PLsoli > cantSol) {
            countVal = countVal + 1;
            if (PLcont > cantCon) {
              this.productoForm.controls['cantidadProducto' + this.productosList[i].noProducto].setValue(null);
            }
            if (PLpzas > cantPzs) {
              this.productoForm.controls['piezasContenedorProducto' + this.productosList[i].noProducto].setValue(null);
            }
          }

          if (pszOrig == 1 && PLpzas > 1) {
            decimVal = decimVal + 1;
            this.productoForm.controls['piezasContenedorProducto' + this.productosList[i].noProducto].setValue(null);
          }
        } else {
          cantZero = cantZero + 1;
          if (PLcont <= 0) {
            this.productoForm.controls['cantidadProducto' + this.productosList[i].noProducto].setValue(null);
          }
          if (PLpzas <= 0) {
            this.productoForm.controls['piezasContenedorProducto' + this.productosList[i].noProducto].setValue(null);
          }
        }
      }

      if (this.isUpdate) {
        this.salidaForm.controls['statusSalida'].enable();
        for (let i = 0; i < this.productosList.length; i++) {
          this.productoForm.controls['cantidadProducto' + this.productosList[i].noProducto].enable();
          this.productoForm.controls['piezasContenedorProducto' + this.productosList[i].noProducto].enable();
        }
      } else {
        this.salidaForm.enable();
        this.salidaForm.controls['noSalida'].disable();
        for (let i = 0; i < this.productosList.length; i++) {
          this.productoForm.controls['nombreProducto' + this.productosList[i].noProducto].enable();
          this.productoForm.controls['cantidadProducto' + this.productosList[i].noProducto].enable();
          this.productoForm.controls['piezasContenedorProducto' + this.productosList[i].noProducto].enable();
        }
      }

      if (cantZero > 0) {
        this._generalService
          .toastCall("No se puede dar salida a cantidades nulas o negativas");
      } else {
        if (countVal > 0 || decimVal > 0) {
          if (countVal > 0) {
            this._generalService.toastCall("Las cantidades son mayores a las disponibles.");
          }
          if (decimVal > 0) {
            this._generalService.toastCall("Las piezas por contenedor de algunos productos no puede ser mayor a 1.");
          }
        }
        if (countVal == 0 && decimVal == 0) {
          if (this.isUpdate) {
            this.submitUpdate();
          } else {
            this.onSubmit();
          }
        }
      }
    } else {
      this._generalService
        .toastCall("Registra al menos un producto para guardar la Salida.");
    }
    this.salidaForm.updateValueAndValidity();
    this.productoForm.updateValueAndValidity();
  }

  validacionInputDecimales(e: any, valor: any, decimales: number, pszCont: any, permDec: any, item) {
    let numComp = valor + e.key;
    numComp = Number(numComp);

    if (permDec && pszCont == 1) {
      if (numComp > 1) {
        this._generalService.toastCall("No se permiten valores mayor a 1 en este producto");
      } else {
        this.inputNumerosConDecimales(e, valor, decimales);
      }
    }
    if (permDec && pszCont > 1) {
      this.inputNumerosConDecimales(e, valor, decimales)
    }
    if (!permDec && pszCont == 1) {
      this.productoForm.controls['piezasContenedorProducto' + this.productosList[item].noProducto].disable();
    }
    if (!permDec && pszCont > 1) {
      this.inputNumerosEnteros(e, valor);
    }
    return;
  }

  hasDecimalPlace(value: any, decimales: any) {
    // Verifica que solo cuente con las decimales que se establecio en el input
    const ed = value.split(".");
    if (ed.length > 1) {
      return ed[1].length > 2;
    }
    else {
      return false;
    }
  }

  inputNumerosConDecimales(e: any, valor: any, decimales: number): boolean {
    // Verifica que la tecla ingresada fuera copiar, pegar, eliminar, numeros o puntos decimales
    if ([8, 9, 13, 27, 46, 110, 190].indexOf(e.keyCode) !== -1 || (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode === 67 && e.ctrlKey === true) || (e.keyCode === 86 && e.ctrlKey === true) ||
      (e.keyCode === 88 && e.ctrlKey === true)) {

      const character = String.fromCharCode(e.keyCode);
      valor = (valor) ? valor : '';
      const newValue: any = valor + character;
      // Verifica que no tenga más de un punto y que solo cuente con las decimales que se establecio en el input
      if (isNaN(newValue) || this.hasDecimalPlace(newValue, decimales)) {
        e.preventDefault();
        return false;
      }
      else {
        return;
      }
    }
    else {
      e.preventDefault();
      return false;
    }
  }

  inputNumerosEnteros(event: any, valor: any) {
    const e = event as KeyboardEvent;

    // Verifica que la tecla ingresada fuera copiar, pegar, eliminar o numeros 
    if ([8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 || (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode === 67 && e.ctrlKey === true) || (e.keyCode === 86 && e.ctrlKey === true) ||
      (e.keyCode === 88 && e.ctrlKey === true)) {
      return;
    }
    else {
      e.preventDefault();
      return false;
    }
  }

  onPaste(e: any) {
    e.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./src/app/almacen/salidas/agregar/agregarSalida.component.ts